import { SET_DESIGNATOR_LIST, SET_UNIQUE_DESIGNATOR_LIST, SET_DESIGNATOR } from './types.js'

export default {
  [SET_DESIGNATOR_LIST] (state, item) {
    state.feedDesignatorList.push(item)
  },
  [SET_UNIQUE_DESIGNATOR_LIST] (state, list) {
    state.uniqueDesignators = list
  },
  [SET_DESIGNATOR] (state, payload) {
    state.feedDesignator = payload
  }
}
